import * as types from "../../actions/companylevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.COMPANY_OPTION_ASSIGN_EMPLOYER_DEDUCTION_EARNING_LIST:
      return action.payload.data;

    default:
      return state;
  }
}
